export default __webpack_public_path__ + "media/images/banners/months/bnr_1-1238be593530e79919cd23a383d0f57a.jpg";